"use client";

import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { useDropEligibility, useDropStore } from "@/components/collection/drops/components/CollectionDropContext";
import { DropStatus } from "@/components/collection/drops/constants";
import { useMintProgressSubscription } from "@/components/collection/drops/use-mint-progress-subscription";
import { withSuspense } from "@/components/suspense/WithSuspense";
export const DropSync = withSuspense(function DropSync({
  collectionSlug,
  children
}) {
  const [setTotalSupply, updateTotalSupplyPerToken, stages, activeStageIndex, status, syncActiveStageAndStatus] = useDropStore(useShallow(state => [state.setTotalSupply, state.updateTotalSupplyPerToken, state.stages, state.activeStageIndex, state.status, state.syncActiveStageAndStatus]));
  useMintProgressSubscription(collectionSlug, ({
    totalSupply,
    totalSupplyPerToken
  }) => {
    setTotalSupply(totalSupply);
    if (totalSupplyPerToken) {
      updateTotalSupplyPerToken(totalSupplyPerToken);
    }
  });

  // initialize eligibility data
  useDropEligibility(collectionSlug);

  // Effect to handle stage transitions
  useEffect(() => {
    if (!stages.length) {
      return;
    }

    // Find the current stage
    const currentStage = stages.find(stage => stage.stageIndex === activeStageIndex);
    if (!currentStage) {
      return;
    }
    const now = Date.now();
    let timeoutTime;
    if (status === DropStatus.MINTING_SOON && currentStage.startTime) {
      // If minting soon, set timeout for stage start
      const startTime = new Date(currentStage.startTime).getTime();
      timeoutTime = startTime - now;
    } else if (status === DropStatus.MINTING && currentStage.endTime) {
      // If currently minting, set timeout for stage end
      const endTime = new Date(currentStage.endTime).getTime();
      timeoutTime = endTime - now;
    } else {
      // Don't set timeouts for ended drops
      return;
    }
    if (timeoutTime > 0) {
      // Set timeout to trigger recalculation at appropriate time
      const timeout = setTimeout(() => {
        syncActiveStageAndStatus();
      }, timeoutTime);
      return () => clearTimeout(timeout);
    }
  }, [stages, activeStageIndex, status, syncActiveStageAndStatus]);
  return children;
}, {
  fallback: ({
    children
  }) => children
});